export default __webpack_public_path__ + "static/media/rightArrowsWhite.9bb803e3.svg";